import { getApiInstance, getOAuthToken } from './ApiToken'

export default {
  async getByMarketSessions (marketSessionId) {
    const api = await getApiInstance()
    try {
      const response = api.get('validatedOutcome/market-session/' + marketSessionId)
      return response
    } catch (error) {
      if (error.response && error.response.status === 401) {
        getOAuthToken()
        const api = getApiInstance()
        const response = api.get('validatedOutcome/market-session/' + marketSessionId)
        return response
      }
      throw error
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/ValidatedOutcomesService.js